import {
  BodyTextWithBulletPoints,
  CheckIcon,
  TooltipBody,
  TooltipHeading,
  TooltipWrapper
} from 'components/ShopResultItem/VerificationTooltipContent/VerificationTooltipContent.styles';
import { useIntl } from 'react-intl';
import React from 'react';
import { colorsVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { Shop } from 'models/Shop';

export default function VerificationTooltipContent({ shop }: { shop: Shop }) {
  const { formatMessage, formatDate } = useIntl();

  return (
    <TooltipWrapper>
      <TooltipHeading>
        <CheckIcon
          iconName={'feedback-check-circle'}
          iconSize={'16px'}
          color={colorsVariables.GREEN_500}
          lineHeight={'20px'}
        />
        <span>
          {formatMessage({
            id: 'CLAIM_STATUS.CLAIMED.HEADING'
          })}
        </span>
      </TooltipHeading>
      <BodyTextWithBulletPoints
        dangerouslySetInnerHTML={{
          __html: formatMessage({
            id: 'CLAIM_STATUS.CLAIMED.TEXT'
          })
        }}
      />
      {shop.profileType === 'member' && (
        <>
          <TooltipHeading>
            <CheckIcon
              iconName={'feedback-check-circle'}
              iconSize={'16px'}
              color={colorsVariables.GREEN_500}
              lineHeight={'20px'}
            />
            {formatMessage({
              id: 'CLAIM_STATUS.MEMBER.HEADING'
            })}
          </TooltipHeading>
          <TooltipBody>
            {formatMessage(
              {
                id: 'CLAIM_STATUS.MEMBER.BODY'
              },
              {
                CompanyName: shop.shopName,
                date: formatDate(shop.contractStartDate, {
                  dateStyle: 'medium'
                })
              }
            )}
          </TooltipBody>
        </>
      )}
    </TooltipWrapper>
  );
}
